import styled from 'styled-components';
import { CLOUD_ICON } from '../../config/media';



export const OverviewWrapper = styled.div`
    color: #000;
    padding-bottom: 2rem;
    .status-wrapper {
        background-color: #212121;
        padding: 2rem 3rem;
    }
    .main-title {
        font-size: 18px;
        font-weight: bold;
    }
    .sub-content {
        font-size: 14px;
        &.content-weight {
            font-weight: bold;
        }
    }
    .sub-content-margin {
        margin-top: 0.5rem;
    }
    .margin-space {
        margin-top: 1rem;
    }
    .hosting-container .flex-container .ant-switch {
        background-color: #29292C;
    }
    .ant-switch-checked {
        background-color: #BFBFBF;
    }
    .ant-switch::after {
        background-color: #0000FF;
    }
    .ant-switch-checked::after {
        background-color: #0000FF;
        background-image: url(${CLOUD_ICON});
    }
    .requirement-icon {
        width: 0.75rem;
    }
    .sub-point {
        font-weight: normal;
    }
    .container {
        .flex-content {
            display: flex;
        }
        .tick-img {
            width: 46px;
            height: 43px;
        }
        .exclamation-icon {
            margin-right: 10px;
        }
        .status-content-header {
            color: #A8A8B1;
            margin-bottom: 1px;
            .underline {
                background-color: #808083;
                height: 1px;
                margin-top: 1px;
                width: 75px;
            }
        }
        .status-content {
            margin-top: 10px;
        }
        .content-wrapper {
            margin-left: 14px;
            font-size: 14px;
            color: #808083;
            .content {
                font-weight: bold;
                color: #ffffff;
            }
        }
        .update-info {
            margin: 0.2rem 0rem 0rem 4rem;
            color: #F28041;
        }
        .button-container {
            margin-top: 1rem;
        }
    }
    .host-wrapper {
        background-color: #212121;
        margin-top:2rem;
        padding: 2rem 3rem;
    }
    .hosting-container {
        /* margin-top: 2rem; */
        .flex-container {
            display: flex;
            align-items: center;
            margin-top: 2rem;
            .toggle-wrapper {
                width: 30%;
                .title {
                    font-size: 13px;
                    margin: 10px 0px 5px 24px;
                }
                .toggle-menu {
                    font-size: 9px;
                    margin-left: 5px;
                    margin-Right: 5px;
                    color: #B3B3B3;
                }
                .active {
                    color: #000000;
                }
            }
            .toggle-disable-wrapper {
                z-index: 2;
                padding-bottom: 1.5rem;
                .title {
                    font-size: 13px;
                    margin: 10px 0px 5px 24px;
                    &.title-color {
                        color: #ffffff;
                    }
                    &.disable-color {
                        color: #B3B3B3;
                    }
                }
                .switch-container {
                    margin-left: 5px;
                    margin-right: 5px;
                }
                .toggle-menu-disable {
                    color: #A8A8B1;
                    background: #212121;
                    font-size: 9px;
                    padding: 1px 0px;
                }
                .active {
                    color: #fff;
                    margin-top: 6px;
                    z-index: 10;
                    background-color: #212121;
                }
            }
            .toggle-description {
                color:  #A8A8B1;
                margin-left: 15px;
                width: 346px;
            }
            .ant-switch {
                min-width: 55px;
                height: 26px;
            }
            .ant-switch-loading-icon, .ant-switch::after {
                width: 22px;
                height: 22px;
            }
            .box-container {
                font-size: 10px;
                height: 45px;
                width: 130px;
                margin-top: 0.6rem;
                border: 1px solid #7a7a7a;
                border-radius: 6px;
                display: flex;
                align-items: center;
                .content {
                    margin: 5px 10px;
                }
            }
            .right-path {
                position: relative;
                left: 8px;
            }
            .left-path {
                position: relative;
                right: 8px;
                width: 155px;
            }
        }
    }
    .diy-container {
        width: 34rem;
        margin-top: 2rem;
        color: #A8A8B1;
        .horizontel-line {
            border: 1px solid #aca5a5;
            width: 20%;
        }
        .ant-btn-primary {
            width: 250px;
            height: 35px;
        }   
        .footer-container {
            width: 50%;
            .footer-content {
                font-size: 10px;
                color: #545454;
            }
        }
    }
    .cloud-container {
        margin-top: 2rem;
        width: 25rem;
        .ant-btn-primary {
            width: 250px;
            height: 35px;
        }
    }
    .link {
        color: #5985ff;
        cursor: pointer;
    }
    @media (max-width: 960px) {
        .hosting-container {
            .flex-container {
                flex-direction: column;
                margin: 0;
                align-items: flex-start;
                .toggle-description {
                    margin: 0;
                    width: 100%;
                }
            }
        }
        .cloud-container {
            width: 100%;
        }
        .diy-container {
            width: 100%;
            .footer-container{
                width: 100%;
            }
        }
    }
    @media (max-width:425px) {
        .cloud-container .ant-btn-primary {
            width: 100%;
        }
    }
`
export const EnterPriseWrapper = styled.div`
    margin: 1rem 0 0.5rem 0.5rem;
    padding-top: 2rem;
`;

export const DomainWrapper = styled.div`
    .ant-select-selection--multiple .ant-select-selection__placeholder {
        color: #606570;
    }
    .domain-wrapper {
        background-color: #212121;
        padding: 2rem 3rem;
    }
    .email-wrapper {
        background-color: #212121;
        margin-top:2rem;
        padding: 2rem 3rem;
    }
    .title-container {
        color: #000;
        .main-title {
            font-size: 24px;
            font-weight: bold;
        }
        .content {
            font-size: 14px;
        }
        .domain-dash-link-wrapper {
            display:flex;
        }
        .domain-dash-link {
            color: #fff;         
            margin-left: 0.5%;   
        }
        .seo-dash-link {
            color: #ffffff;
        }
    }
    .seo-form-wrapper {
        background-color: #212121;
        padding: 2rem 3rem;
    }
    .ant-switch-checked {
        background-color: #BFBFBF;
    }
    .ant-switch::after {
        background-color: #000;
    }
    .toggle-wrapper {
        .title {
            color: #545454;
            font-size: 11px;
            margin: 0.5rem 0rem 0.5rem 6.5rem;
        }
        .flex-container {
            display: flex;
            .toggle-menu {
                font-size: 9px;
                font-weight: bold;
                margin-left: 10px;
                margin-Right: 10px;
                color: #B3B3B3;
                text-align: center;
            }
            .sub-domain-title {
                color: #B3B3B3;
            }
            .active {
                color: #000000;
            }
        }
    }
    .built-domain-container {
        margin-top: 3rem;
        color: #000;
        .ant-input {
            width: 300px;
            border-radius: 0px;
            border: 2px solid #3A4FFF;
            color: #000;
        }
        .title {
            font-size: 15.5px;
            font-weight: bold;
        }
        .margin-space {
            margin-top: 1rem;
        }
        .ant-btn {
            width: 130px;
        }
    }
    .custom-domain-container {
        width: 45%;
        padding: 1rem;
        font-size: 13px;
        .custom-domain-content {
            margin-left: 0.5rem;
            }
        .content-icon {
            width: 2rem;
        }
        .ant-btn {
            width: 200px;
        }
        .btn-wrapper {
            margin-top: 1rem;
        }
        .bold {
            font-weight: bold;
        }
        .space {
            margin-left: 3px;
        }
        .d-flex {
            display: flex;
            align-items: center;
        }
    }
    .divider {
        border-bottom: 1px solid #A8A8B1;
        width: 120px;
        margin: 2rem 0;
    }
    .seo-container {
        color: #ffffff;
        .title-container {
            background-color: #212121;
            padding: 2rem 3rem;
            margin-bottom:2rem;
        }
        .bold {
            font-weight: bold;
            color: #ffffff;
            font-size: 15px;
        }
        .input-container {
            margin: 2rem 0;
        }
        .input {
            margin-top: 8px;
            width: 480px;
        }
        .custom-select {
            li {
                display: none;
            }
            &:hover {
                li{
                    display: block;
                }
            }
        }
        .html-text-area {
            border: 1px solid #A8A8B1;
            height: 300px;
            width: 600px;
            background-color: #212121;
        }
        .info-text {
            color: #A8A8B1 !important;
            a {
                color: #A8A8B1 !important;
            }
        }
        .mt-1 {
            margin-top: 1rem;
        }
        .save-btn {
            width: 160px;
        }
        .warn-icon {
            margin-right: 5px;
        }
        .down-icon {
            margin-left: 5px;
        }
        .pointer {
            cursor: pointer;
        }
    }
    @media (max-width: 960px) {
        .custom-domain-container {
            width: 100%;
            padding: 10px;
        }
        .seo-container {
            .input {
                width: 100%;
            }
        }
    }
    @media (max-width:450px) {
        .title-container {
            .domain-dash-link-wrapper {
                display: block;
            }
        }
    }
    @media (max-width:320px) {
        .custom-domain-container {
            .ant-btn {
                width: 100%;
            }
            .domain-container {
                flex-direction:column;
                .custom-domain-content {
                    margin-top: 0.5rem;
                    width: 100%;
                }
            }
        }
    }
`
export const ManageWrapper = styled.div`
    color: #ffffff;
    padding-bottom: 2rem;
    .main-container {
        margin-top: 1rem;
        background-color: #212121;
        padding: 2rem 3rem;
        .main-title {
            font-size: 24px;
            font-weight: bolder;
        }
        .btn-wrapper {
            margin-top: 1.5rem;
        }
        .ant-btn {
            width: 300px;
            height: 45px;
        }
    }

    .cloud-container {
        padding: 1rem 2rem !important;
    }
    .d-flex{
        display: flex;
        align-items:center;
    }
    .cloud-icon-normal {
        width: 3.5rem;
        height: 2.5rem;
    }
    .go-live-wrapper {
        margin-left: 58px;

        .region-container {
            margin-top:10px;
            display:flex !important;
            align-items:center;
            p {
                margin-bottom :0px;
                margin-left:5px;
            }

            svg {
                color:green;
                font-size:16px;
            }

            .change-text {
                color: #3E4EF5;
                text-decoration:underline;
                cursor:pointer;
            }

        }
    }
    .link {
        color: #5985ff;
        cursor: pointer;
    }
    .list-head {
        font-weight: bold;
    }
    .sub-container {
        margin-top: 1rem;
        /* width: 35rem; */
        &.disable {
            pointer-events: none;
            opacity: 0.4;
        }
        .btn-container {
            margin-top: 1rem;
            margin-bottom: 0.5rem;
            .orange-btn {
                background-color: #FF6F00;
                border: none;
            }
        }
        .switch-title {
            color: #545454;
            margin: 0.5rem;
            font-size: 11px;
        }
        .switch-label {
            font-size: 10px;
            margin: 0px 5px;
        }
        .switch-wrapper {
            margin: 1rem 0rem;
            .ant-switch {
                min-width: 52px;
                height: 30px;
            }
            .ant-switch::after {
                width: 26px;
                height: 26px;
            }
            .label-inactive {
                color: #CCCCCC;
            }
        }
        .content-width {
            width: 45%;
        }

        .pt-0 {
            padding-top :0px !important;
        }

        .sub-content-list {
            /* padding: 1.5rem 0rem;     */
            background-color: #212121;
            padding: 2rem 3rem;
            margin-bottom: 1rem;

            .sub-content-region-container {
                display:flex;
                align-items:center;
                p {
                    margin-left:5px;
                }
            }
        }
        .separator {
            background-color: #707070;
            height: 1px;
            width: 15rem;
        }
        .d-flex {
            display: flex;
            // align-items: center;
        }
        .align-center {
            align-items: center;
        }
        .pointer {
            cursor: pointer;
        }
        .disabled {
            cursor: not-allowed;
            pointer-events: none;
            opacity: 0.5;
        }
        .exclamation-icon {
            margin-right: 10px;
            padding-top: 3px;
        }
        .description {
            color: #808083;
        }
        .sub-title {
            font-size: 18px;
            font-weight: bold;
            margin-bottom: 5px;
        }
        .warning-zone {
            .ant-btn {
                color: #fff;
                background-color: #F28041;
            }
        }
        .danger-waring-text {
            color: #FF0000;
        }
        .exchange-state {
            margin-top: 1.5rem;
            width: 23rem;
            .exchange-state-title {
                font-size: 15px;
                font-weight: bold;
            }
        }
        .show-advanced {
            margin-top: 8px;
            .open, .close {
                cursor: pointer;
            }
            .open:after {
                content: "";
                background-color:white;
                display: block;
                position: absolute;
                width: 0;
                height: 0;
                border-left: .3rem solid transparent;
                border-right: .3rem solid transparent;
                display: inline-block;
                margin-left: .4rem;
                position: relative;
                top: calc(50% - .6rem);
                border-top: .3rem solid #000000;
                margin-top: 0;
                margin-bottom: 1px;
            }
            .close:after {
                content: "";
                display: block;
                background-color:white;
                position: absolute;
                width: 0;
                height: 0;
                border-left: .3rem solid transparent;
                border-right: .3rem solid transparent;
                display: inline-block;
                margin-left: .4rem;
                position: relative;
                top: calc(50% - .6rem);
                border-bottom: .3rem solid #000000;
                margin-bottom: 2px;
            }
        }
        .danger-zone {
            border: 1px solid #707070;
            background: #ff800033 0% 0% no-repeat padding-box;
            margin: 1rem 0rem;
            padding: 1.5rem;
        }
        .terminate-wrapper{
            display: flex;
            flex-direction: column;
            .terminate-link {
                cursor: pointer;
                font-size: 10px;
                text-decoration: underline;
            }
            .terminate-content {
                font-size: 10px;
            }
        }
        .ant-btn {
            width: 150px;
            height: 26px;
            display: flex;
            justify-content: center;
            align-items: center;
        }
        .upgrade-section {
            display: flex;
            justify-content: space-between;
            background-color: #F1F1F1;
            padding: 20px;
            margin: 20px 0;
            .btn-wrapper {
                display: flex;
                justify-content: center;
                align-items: center;
                .ant-btn {
                    background-color: #288500;
                    color: #FFFFFF;
                    border-color: #288500 !important;
                    height: 30px;
                }
            }
            .title-text {
                font-weight: bold;
            }
        }
    }
    .disable-content {
        opacity: 0.4;
        pointer-events: none;
    }
    @media (max-width: 960px) {
        .sub-container {
            width: 100%;
            .exchange-state {
                width: 100%;
            }
        }
    }
    @media (max-width:425px) {
        .main-container {
            padding: 2rem 0.5rem;
            .flex-container {
                flex-direction:column;
            }
            .region-wrapper {
                margin-left:0px;
                display: flex;
                justify-content:center;
            }
            .go-live-wrapper {
                margin-left: 0px;
                .text-content {
                    text-align:center;
                }
            }
            .ant-btn {
                width: 100%;
            }
        }
    }
    @media (max-width:310px) {
        .go-live-wrapper {
            .region-container {
                flex-direction: column;
            }
        }
    }
`;

export const ConfirmationWrapper = styled.div`
    padding: 1.5rem 2rem;
    color: #ffffff;
    &.terminate-wrapper {
        background-color: #FF0000;
        border-radius: 4px;
        color: #ffffff;
        padding: 10px 20px;

        .content-wrapper {
            color: #ffffff;
            padding: 0px 10px;
        }
        .content-description {
            width: 23rem;
        }
    }
    .understand-input-wrapper {
        margin: 1.5rem 0rem;
    }
    .title {
        font-size: 18px;
        font-weight: bold;
    }
    .cloud_icon {
        height: 2.5rem;
        margin-right: 0.5rem;
        width: 2.5rem;
    }
    .cloud-icon-wrapper {
        height: 8rem;
        margin: 0.5rem auto;
        width: 8rem;
    }
    .restart-icon {
        height: 8rem;
        margin: 2rem auto;
        width: 8rem;
    }
    .requirement-icon {
        height: 0.75rem;
        width: 0.75rem;
    }
    .close-terminate-icon {
        width: 6rem;
        height: 6rem;
        margin: 18px 0px;
    }
    .flex-content {
        display: flex;
        align-items: center;
    }
    .align-content-top {
        align-items: flex-start;
    }
    .flex-column {
        flex-direction: column;
    }
    .text-center {
        text-align: center;
    }
    .flex {
        flex: 1;
    }
    .content-title {
        font-weight: bold;
    }
    .content-wrapper {
        margin: 0.75rem 0rem;
        .ant-input {
            width: 65%;
        }
        .ant-btn {
            width: 100%;
        }
    }
    .todo-list-wrapper {
        margin-bottom: 2rem;
    }
    .todo-list {
        .list-text {
            margin-left: 5px;
        }
    }
    .btn-wrapper {
        display: flex;
        margin: 2rem 0rem 1rem;
        .ant-btn {
            flex: 1;
        }
        .close-btn {
            background-color: #ffffff;
            border-color: #ffffff;
            color: #000000;
        }
        .proceed-btn {
            background-color: #000000;
            border-color: #000000;
            color: #ffffff;
            width: 100%;
        }
        .divider {
            margin: 0.25rem;
        }
        .terminate-warning {
            background-color: #F28041;
            border-color: #F28041;

            .ant-btn-primary:hover, .ant-btn-primary:focus {
                background-color: #F28041;
                border-color: #F28041;
            }
        }
        .terminate-confirm {
            background-color: #FF0000;
            border-color: #FF0000;
        }
        .terminate-cancel {
            background-color: #4C00FF;
            border-color: #4C00FF;
        }
    }
    .pt-15 {
        padding-top: 15px;
    }
    .mt-15 {
        margin-top: 25px;
    }
    .w-100 {
        width: 100%;
    }
    .events-animation-wrapper-golive canvas{
        width: 100% !important;
        height: 100% !important;
    }
    .events-animation-wrapper canvas, .events-animation-wrapper-restart canvas {
        width: 396px !important;
        height: 298px !important;
    }
    @media (max-width: 480px) {
    .events-animation-wrapper canvas, .events-animation-wrapper-restart canvas {
        width: 296px !important;
        height: 198px !important;
    }
    }
    @media (max-width: 280px) {
        .flex-container {
            flex-direction: column;
        }
        .events-animation-wrapper canvas, .events-animation-wrapper-restart canvas {
            width: 190px !important;
            height: 160px !important;
        }
    }
`;

export const EventWrapper = styled.div`
    .main-content{
        display: flex;
        justify-content: space-between;
        margin: 1rem 0rem 2rem 0rem;
        color: #ffffff;
        padding: 2rem 3rem;
        background: #212121;
        .main-title {
            font-size: 18px;
            font-weight: bold;
            color: #ffffff;
        }
    }
    .ant-table-thead {
        tr {
            th:nth-child(2) {
                padding-left: 55px !important;
            }
        }
    }
    .ant-table-tbody {
        tr {
            td:nth-child(2) {
                padding-left: 43px !important;
            }
        }
        td {
            width: 30%;
            .ml-2 {
                margin-left: 10px;
                .anchor {
                    color: #3A4FFF;
                    text-decoration: underline;
                    cursor: pointer;
                }
            }
        }
        .d-flex {
            display: flex;
            align-items: center;
        }
        .anticon {
            border: 1px solid #e8e8e8;
            padding: 3.5px;
            background-color: #ffffff;
            svg {
                font-size: 13px;
            }
        }
        .anticon:hover, .anticon:focus-within {
            border: 1px solid #2930ff !important;
            svg {
                color: #2930ff !important;
            }
        }
        tr.ant-table-expanded-row, tr.ant-table-expanded-row:hover {
            background: #0E0E0F !important;
        }
        .text-capitalize {
            text-transform: capitalize;
        }
        .expand-icon-container {
            .anticon {
                border: 1px solid #3A4FFF;
                color: #3A4FFF;
                background-color: #0E0E0F;
            }
        }
        .success-text-container {
            .anticon {
                border: none; 
                background: unset;
            }
            .status-success-icon{
                border: none !important;
                color: unset !important;
                pointer-events: none;
            }
            .status-success-icon :hover {
                color: unset !important;
                pointer-events: none;
            }
        }
        .ant-table-expanded-row.ant-table-expanded-row-level-1, .ant-table-expanded-row.ant-table-expanded-row-level-1:hover {
            background: #212121 !important;
        }
    }
    .fail-container {
        .fail-img {
            width: 6rem !important;
            height: 4rem !important;
            background-repeat: no-repeat;
            background-size: cover;
            background-position: center;
        }
        .fail-content {
            width: 30%;
            font-size: 12px;
            margin-left: 5px;
            margin-top: 5px;
        }
        .failed-content{
            color: gray;
            font-style: italic;
            margin-top: 10px;
            width: 30%;
            font-size: 11px;
            margin-left: 5px;
        }
    }
    .td-cell-container {
        max-height: 130px;
        min-height: 150px;
        display: flex;
        align-items: center;
        .cell-container {
            flex-direction: column;
            width: 100%;
            .fail-img {
                width: 12rem;
                min-height: 8rem;
                max-height: 10rem;
                background-repeat: no-repeat;
                background-position: center;
            }
            .rive-animation {
                width: 170px;
                height: 140px;
                position: relative;
                .backup-gif {
                    height: 80%;
                    margin: 10% 0 0 10%;
                }
            }
            .rive-animation canvas {
                width: 200px !important;
                height: 170px !important;
            }
            .progress-percentage-wrapper{
                width: 23%;
                display: flex;
                justify-content: right;
            }
            .width-40 {
                width: 17%;
            }
            .check-icon-container {
                border-radius: 50%;
                background-color: #52C41A;
                color: #ffffff;
                border: none;
                .anticon {
                    border:none;
                    background: none;
                    padding: unset;
                    width: 1rem;
                    height: 1rem;
                    svg {
                        font-size: 10px;
                        padding-bottom: 3px;
                    }
                }
            }
        }
    }
    .loading-image {
        width: 25px;
    }
    @media (max-width: 960px) {
        .table-wrapper {
            overflow-x: scroll;
        }
    }
    @media (max-width: 425px) {
        .main-content {
            flex-direction:column;
            button {
                margin-top:1rem;
            }
        }
        .td-cell-container {
        .width-40 {
            width: 45% !important;
            }
        }
    }
    @media (min-width: 426px) and (max-width: 650px) {
        .td-cell-container {
        .width-40 {
            width: 40% !important;
            }
        }
    }
    @media (min-width: 651px) and (max-width: 750px) {
        .td-cell-container {
        .width-40 {
            width: 35% !important;
            }
        }
    }
    @media (min-width: 751px) and (max-width: 1400px) {
        .td-cell-container {
        .width-40 {
            width: 30% !important;
            }
        }
    }
    @media (min-width: 1401px) and (max-width: 1600px) {
        .td-cell-container {
        .width-40 {
            width: 25% !important;
            }
        }
    }
    @media (min-width: 1601px) and (max-width: 1800px) {
        .td-cell-container {
        .width-40 {
            width: 22% !important;
            }
        }
    }
    @media (min-width: 1801px) and (max-width: 2000px) {
        .td-cell-container {
        .width-40 {
            width: 17% !important;
            }
        }
    }
    @media (min-width: 2001px) and (max-width: 2200px) {
        .td-cell-container {
        .width-40 {
            width: 15% !important;
            }
        }
    }
    @media (min-width: 2201px) and (max-width: 2560px) {
        .td-cell-container {
        .width-40 {
            width: 13% !important;
            }
        }
    }
`;

export const LogsBackupWrapper = styled.div`
  color: #ffffff;
  .btn-wrapper {
    display: flex;
    justify-content: center;
    margin-top: 2rem;
    .ant-btn {
      width: 100%;
      height: 40px;
      background-color: #3A4FFF;
    }
  }
  .step-1-container {
    .header-txt {
        color: #ffffff;
        font-size: 25px;
        font-weight: bold;
    }
    .date-wrapper {
        width: 50%;
        display: flex;
        justify-content: space-around;
        margin-top: 2rem;
    }
    .ant-calendar-picker {
        width: 50%;
        .ant-calendar-picker-input {
            border: 2px solid #0000FF;
            padding: 0 !important;
            border-radius: unset;
            .ant-calendar-range-picker-input:first-child {
                border-right: 2px solid #0000FF;
            }
            .ant-calendar-range-picker-input {
                width: 50%;
            }
            .ant-calendar-range-picker-separator,
            .anticon {
                display: none;
            }
        }
    }
  }
  .step-2-container {
    padding: 0rem 1rem;
    .img-wrapper{
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .backup-img {
        width: 100px;
    }
    .header-txt {
        font-size: 25px;
        font-weight: bold;
        margin: 2rem 0 1rem 0;
    }
  }
  .backup-wrapper canvas {
    width: 100% !important;
    height: 100% !important;
  }

  @media (max-width: 960px) {
    .step-1-container {
        .date-wrapper, 
        .ant-calendar-picker {
            width: 75%;
        }
    }
  }
`;

export const SEOSuccessModalWrapper = styled.div`
    .seo-modal-container {
        padding-top: 1rem;
        .seo-modal-title {
            display: flex;
            align-items: center;
            .verification-icon {
                width: 20px;
            }
            .title {
                font-size: 18px;
                font-weight: bold;
                margin-left: 5px;
            }
        }
        .seo-modal-content {
            color: #A8A8B1;
            margin: 1rem 0rem;
        }
        .btn-container {
            display: flex;
            justify-content: space-between;
            width: 100%;
            margin-top: 2rem;
            .ant-btn {
                width: 45%;
            }
        }
    }
`;

export const SetupWrapper = styled.div`
.mail-container{
    .icon-container {
        span {
            font-size: 25px;
            color: blue;
        }
    }
    .title {
        font-size: 18px;
        font-weight: bold;
        margin-top: 1rem;
    }
    .btn-container {
        display: flex;
        justify-content: space-between;
        width: 100%;
        margin-top: 3rem;
        .ant-btn {
            width: 48%;
        }
    }
    .text-container{
        margin-top: 2rem;
    }
    .para-container{
        margin-top: 1rem;
    }
}
.container {
    padding: 0.5rem 1rem 1rem;
    margin-top: 0.5rem;
    color: #fff;
    .header {
        font-size: 24px;
        font-weight: bold;
    }
    .title {
        font-size: 16px;
        font-weight: bold;
        margin-top:1rem;
    }
    .ant-input {
        width: 310px;
        border-radius: 0px;
        border: 2px solid #3A4FFF;
    }
    .custom-input {
        display:flex;
    }
    .input-wrapper {
        margin-top: 1rem;
        .box-content {
            display: flex;
            .box-container {
                display: flex;
                padding: 3px 5px;
                /* white-space: nowrap; */
                margin: 5px 0px;
                background: #0000000D 0% 0% no-repeat padding-box;
                border: 2px solid #888888;
                opacity: 1;
                width: 95%;
    
                .first-column {
                    padding: 0px 5px;
                    width: 35%;
                    background: #212121 0% 0% no-repeat padding-box;
                    border: 1px solid #e8e8e8;
                    align-items: center;
                    opacity: 1;
                }
                .second-column {
                    text-align: center;
                    width: 15%;
                    background-color: #212121;
                    align-items: center;
                }
                .third-column {
                    padding: 0px 5px;
                    width: 50%;
                    background: #212121 0% 0% no-repeat padding-box;
                    border: 1px solid #e8e8e8;
                    align-items: center;
                    opacity: 1;
                }
                .first-column,
                .second-column,
                .third-column {
                    .column-container {
                        text-decoration: underline;
                        color: #0000FF;
                        cursor: pointer;
                    }
                }
                .first-column,
                .third-column {
                    display: flex;
                    justify-content: space-between;
                }
                .value-container {
                    overflow: hidden;
                    /* white-space: nowrap; */
                    text-overflow: ellipsis;
                }
            }
            .icon-container {
                align-items: center;
                display: flex;
                padding: 0px 5px;
                .content-icon {
                    width: 1.5rem;
                }
                .circle-minus {
                    border: 1px solid white;
                    width: 23px;
                    display: flex;
                    justify-content: center;
                    border-radius: 1.5rem;
                    background-color: lightgray;
                    font-weight: bold;
                    color: gray;
                }
            }
        }
        .chk-btn-container {
            margin-top: 0.5rem;
            .ant-btn {
                width: 190px;
                height: 30px;
            }
            .space {
                margin-left: 10px;
            }
            .anchor {
                margin-top: 10px;
            }
        }
    }
    .status {
            margin-top: 1rem;
            &.error-status {
                .ant-badge-status-text {
                    color: #FF0000;
                }
            }
            &.success-status {
                .ant-badge-status-text {
                    color: #288500;
                } 
            }
        }
    .ant-btn-primary[disabled] {
        color: #FFFFFF;
        background-color: #42454D;
    }
    .ant-btn {
        width: 49%;
        height: 45px;
    }
    .btn-container {
        display: flex;
        justify-content: space-between;
        margin-top: 5rem;
    }
    .anchor {
        color: #fff;
        margin-top: 1rem;
    }
    .anchor a {
        color: #3A4FFF;
        text-decoration: underline;
    }
    .special-char {
        height: 35px;
        margin-left: 10px;
        margin-right: 10px;
        display: flex;
        align-items: center;
    }
    .image-container {
        display: flex;
        justify-content: center;
        padding-top: 1.5rem;
    }
    .margin-05 {
        margin-top:0.5rem;
    }
    .text-container{
        margin-top:1.5rem;
    }
    .setup-btn-container {
        button {
            height:35px;
            width: 100%;
            margin-top: 2rem;
        }
    }
}
.events-email-animation{
    width: 60% !important;
    margin-left: 18%;
    canvas {
        width: 100% !important;
        height: 100% !important;
    }
}
@media (max-width: 425px) {
    .btn-container {
            flex-direction: column;
            button {
                width: 100%!important;
                margin-bottom: 1rem;
            }
    }
    .container .ant-input {
        width: 100%;
    }
    .ant-form-horizontal {
        .input-wrapper {
            .setup-domain-input-container {
                width: 100%;
            }
        }
    }
}
`;

export const SuccessEmailWrapper = styled.div`
.container {
    padding: 0.5rem 1rem 1rem;
    margin-top: 0.5rem;
    color: #000;
    .title {
        font-size: 16px;
        font-weight: bold;
        margin-top:1rem;
    }
    .image-container {
        display: flex;
        justify-content: center;
        padding-top: 1.5rem;
    }
    .margin-05 {
        margin-top:0.5rem;
    }
    .setup-btn-container {
        button {
            height:35px;
            width: 100%;
            margin-top: 2rem;
        }
    }
}
.events-email-animation {
    canvas {
        width: 100% !important;
        height: 100% !important;
    }
}
`

export const RegionModalWrapper = styled.div`
   color: #ffffff !important;
   text-align: center;

   .d-flex {
    display:flex;
   }

   .mr-2 {
    margin:2rem;
   }

   .placeholder-icon {
    position: absolute;
    right: 0%;
    width: 10rem;
    height: 10rem;
    top: 0%;
    margin: 0px;
   }

   h2 {
    font-weight :bold
   }

   p {
    font-size:12px;
   }

   .step-1-wrapper {
    text-align:left;

    p{
        font-weight:bold;
        color: #ffffff !important;
    }

    .ant-radio-group  {
        display:flex;
        flex-direction:column;

        label {
            margin-bottom:1.5rem;
        }

        .flag-icon {
            width:1rem;
            height:1rem;
        }
    }

    .warning-text {
        display :flex;
        margin-left: 1.5rem;
        p{
            margin-right:5px;
            color: #FF9900 !important;
        }
    }
   }

   .step-2-wrapper {
    text-align:left;

    span {
        font-size :12px;
        font-weight:bold;
    }

    .location-box-container {
        border: 1px solid #FFFFFF;
        width:60%;
        padding:15px 25px;
        margin:3rem 0;

        h2 {
            margin-bottom :0px;
            font-size:14px;
        }

        p {
            font-size:14px
        }

        .float-label {
            position: absolute;
            color: #FFFFFF;
            opacity: 1;
            top: 48%;
            left: 9%;
            line-height:1;
            z-index:3;
            background-color :#29292C;
            padding: 0 10px;
        }
    }

   }

   .footer-btn {
    width:100%;
    display:flex;
    margin-top:2rem;

    .mr-1 {
        margin-right:1rem;
    }

    button {
        width:48%
    }

   }
   @media (max-width: 374px) {
    .footer-btn {
        flex-direction: column;
        Button {
            width: 100%;
            margin-bottom: 1rem;
        }
    }
    .placeholder-icon {
     width: 8rem !important;
     height: 8rem !important;
    }
    .step-2-wrapper {
        text-align:left;

        span {
            font-size :12px;
            font-weight:bold;
        }

    .location-box-container {
        .float-label {
            top: 41% !important;
        }
    }
    }
 }
 @media (max-width: 280px) {
    .placeholder-icon {
        width: 4rem !important;
        height: 8rem !important;
    }
    .step-2-wrapper {
        .location-box-container {
            .float-label {
                top: 46% !important;
                left: 12% !important;
                font-size: 10px;
            }
        }
    }
   }
`
export const MetricsLogsWrapper = styled.div`
    .text-white {
        color: #fff;
    }
    .bold {
        font-weight: bold;
    }
    .title, .header-title {
        font-size: 16px;
        margin-bottom: 10px;
    }
    .header-title {
        margin: 0px !important;
    }
    .metric-log-icon {
        margin-right: 1rem;
    }
    .cloud-metrics-wrapper, .cloud-logs-wrapper {
        padding: 2rem;
        background-color: #212121;
        height: 100%;
        width: 98%;
        margin-left: auto;
        margin-right: auto;
        justify-content: space-between;
        .cloud-content {
            flex-direction: column;
        }
        .logs-btn {
            margin-top: 5px;
        }
    }
    .cloud-link {
        text-decoration: underline;
        color: #5985ff;
        cursor: pointer;
    }
    .iframe-wrapper {
        height: 100vh;
        .title-wrapper {
            justify-content: space-between;
        }
        .view-label {
            width: 9rem;
            font-size: 14px;
            text-decoration: underline;
            text-decoration-color: #A8A8B1;
            color: #fff;
            cursor: pointer;
        }
        .doc-icon {
            width: 8%;
            margin-bottom: 20px;
        }
        .memory-metrics-wrapper,.example-memory-metrics-wrapper, .logs-wrapper, .log-rates-wrapper {
            height: 48%;
            margin: 1rem;
            padding: 2rem;
            background-color: #212121;
            display: flex;
            flex-direction: column;
        }
        .logs-wrapper {
            height: 55% !important;
        }
        .log-rates-wrapper {
            height: 40% !important;
        }
    }
@media (max-width: 550px) {
    .content-wrapper{
        flex-direction: column;
        align-items: center;
    }
    .cloud-metrics-wrapper, .cloud-logs-wrapper {
        flex-direction: column;
        text-align: center;
        .logs-btn {
            margin-top: 1rem;
        }
    }
    .iframe-wrapper {
        height: 100%;   
        .title-wrapper {
            flex-direction: column;
            text-align: center;
            .full-screen-wrapper {
                justify-content: center;
            }
        }
        .doc-icon {
            width: 4%;
        }
    }
   } 
`